/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import { FaHome} from "react-icons/fa";


import pathfinderh from '../../images_logo_vc/pathfinder.jpg'
import afwp from '../../images_logo_vc/afwp.png'
import hiinvestment from '../../images_logo_vc/hiinvestment.png'
import hyundae from '../../images_logo_vc/hyundae.svg'
import penture from '../../images_logo_vc/penture.jpg'
import yuantain from '../../images_logo_vc/yuantain.jpg'
import bnk from '../../images_logo_vc/bnk_venture.bmp'
import square from '../../images_logo_vc/square_ventures_logo.png'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const VentureTable = () => {
    return(
        <div className="sect-01-box-01-exhibitor-regi">
            <div className="sect-tit">{t("exh_vc_table_title")}</div>
            <div className='exhibitor-comp-corp-tbl-wrap'>
                <div className='tbl-exhibitor-comp-corp'>
                    <div style={{display:"inline-block", width:"90%", maxWidth:"1600px"}}>
                    <table>
                        <colgroup>
                            <col width="20%"/>
                            <col width="30%"/>
                            <col width="50%"/>
                        </colgroup>
                        <tbody>
                        <tr class="smallCell purple borderUpBoldPurple">
                            <td>
                                {t("exh_vc_table_col_1")}
                            </td>
                            <td>
                                {t("exh_vc_table_col_2")}
                            </td>
                            <td>
                                {t("exh_vc_table_col_3")}
                            </td>
                        </tr>
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp1_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={pathfinderh}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp1_info")}
                            </td>
                        </tr> 
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp2_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-60 p-12 inline-block'>
                                    <img className="w-full h-full" src={afwp}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp2_info")}
                            </td>
                        </tr> 
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp3_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={yuantain}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp3_info")}
                            </td>
                        </tr> 
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp4_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={penture}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp4_info")}
                            </td>
                        </tr> 
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp5_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={hiinvestment}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp5_info")}
                            </td>
                        </tr> 
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp6_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={hyundae}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp6_info")}
                            </td>
                        </tr>
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp7_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={square}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp7_info")}
                            </td>
                        </tr>
                        <tr class="largeCell">
                            <td className="bigfont">
                                {t("exh_vc_table_comp8_name")}
                            </td>
                            <td className="">
                                <div className='object-fill w-80 p-12 inline-block'>
                                    <img className="w-full h-full" src={bnk}></img>
                                </div>
                            </td>
                            <td class="leftAlign">
                                {t("exh_vc_table_comp8_info")}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VentureTable;